import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  question: '❓ ¿Para qué edades está pensada la guía?',
  answer: 'Está especialmente diseñada para padres de hijos entre 10 y 18 años. Si tu hijo está comenzando la preadolescencia (10-12 años), es el momento ideal para leerla antes de que llegue la tormenta.'
}, {
  question: '❓ ¿Cuánto tiempo necesito para leerla?',
  answer: 'La guía tiene 45 páginas con lenguaje claro y accesible. Puedes leerla en 2-3 horas, o capítulo a capítulo a tu ritmo. Cada capítulo es independiente puedes ir directamente al que más necesitas ahora.'
}, {
  question: '❓ ¿Funciona también para padres separados?',
  answer: 'Absolutamente. Los principios de esta guía son aplicables independientemente de la estructura familiar. De hecho, muchos de los ejercicios pueden hacerse individualmente con resultados inmediatos.'
}, {
  question: '❓ ¿Cómo recibo la guía tras el pago?',
  answer: 'Recibirás un email inmediato con el enlace de descarga. Formato PDF de alta calidad, compatible con cualquier dispositivo: iPad, iPhone, Android, PC o Mac.'
}, {
  question: '❓ ¿Qué pasa si mi situación es muy grave?',
  answer: 'Esta guía es educativa y preventiva no reemplaza la atención psicológica profesional. Si tu hijo está atravesando una crisis severa, te recomendamos buscar apoyo especializado en paralelo. El Bono 1 de Emergencias Emocionales te orientará en esas situaciones.'
}, {
  question: '❓ ¿Puedo compartirla con mi pareja?',
  answer: 'Sí. Al adquirirla puedes compartirla con tu pareja o co-padre/co-madre para trabajar juntos. De hecho, muchos ejercicios están diseñados para hacerse en pareja.'
}];
export function FaqSection() {
  return <section className="py-20 px-5 bg-white" data-id="element-54">
      <div className="max-w-5xl mx-auto" data-id="element-55">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl text-[#1A2744] text-center mb-12" data-id="element-56">
          Preguntas Frecuentes
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-57">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#F7F9FF] rounded-2xl p-7" data-id="element-58">
              <h3 className="text-base font-bold text-[#1A2744] mb-3" data-id="element-59">
                {faq.question}
              </h3>
              <p className="text-sm text-[#718096] leading-relaxed" data-id="element-60">
                {faq.answer}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}